import { alpha, lighten } from '@mui/material';
import { colorTokens } from './colorTokens';
export const getPalette = (mode) => {
    const { slate, zinc, indigo, grey, red, orange, amber, yellow, green, emerald, teal, cyan, sky, violet, blue, purple, fuchsia, pink, rose, lime, } = colorTokens;
    return {
        mode,
        ...(mode === 'light'
            ? {
                // palette values for light mode
                //contrastThreshold: 4.5,
                Avatar: {
                    defaultBg: zinc[500],
                },
                Tooltip: {
                    bg: zinc[700],
                },
                grey: grey,
                slate: slate,
                zinc: zinc,
                indigo: indigo, // only used for primary not having indigo[200]
                purple: purple,
                action: {
                    // hover: zinc[100],
                    // hover: alpha(zinc[950], 0.015),
                    hover: `color-mix(in oklab, ${zinc[950]} 1.5%, transparent)`,
                },
                background: {
                    default: zinc[100],
                    light: zinc[50],
                },
                divider: alpha(zinc[950], 0.1),
                // divider: `color-mix(in oklab, ${zinc[950]} 10%, transparent)`, // Unsupported for some reason
                dividerTranslucent: `color-mix(in oklab, var(--gp-palette-text-primary) 5%, transparent)`,
                text: {
                    primary: zinc[950],
                    secondary: zinc[800],
                    medium: zinc[700],
                    light: zinc[600],
                    muted: zinc[500],
                    disabled: zinc[400],
                    translucent: zinc[300],
                },
                neutral: {
                    // dark: grey[700],
                    // main: grey[500],
                    // light: grey[300],
                    // lighter: grey[200],
                    // //lightest: grey[100],
                    dark: zinc[700],
                    main: zinc[500],
                    light: zinc[300],
                    lighter: zinc[200],
                    //lightest: grey[100],
                    contrastText: '#ffffff', // <Chip color="neutral" /> fails without this.
                },
                // primary: {
                // 	// black 900
                // 	// darkest 800
                // 	darker: indigo[700],
                // 	dark: indigo[600],
                // 	main: indigo[500],
                // 	light: indigo[400],
                // 	lighter: indigo[300],
                // 	lightest: indigo[200],
                // 	background: indigo[100],
                // 	backgroundLight: indigo[50],
                // },
                // secondary: {
                // 	// darkest: purple[800],
                // 	darker: purple[700],
                // 	dark: purple[600],
                // 	main: purple[500],
                // 	light: purple[400],
                // 	lighter: purple[300],
                // 	lightest: purple[200],
                // 	background: purple[100],
                // 	backgroundLight: purple[50],
                // },
                // info: {
                // 	darker: blue[700],
                // 	dark: blue[600],
                // 	main: blue[500],
                // 	light: blue[400],
                // 	lighter: blue[300],
                // 	lightest: blue[200],
                // 	background: blue[100],
                // 	backgroundLight: blue[50],
                // },
                // success: {
                // 	darker: green[700],
                // 	dark: green[600],
                // 	main: green[500],
                // 	light: green[400],
                // 	lighter: green[300],
                // 	lightest: green[200],
                // 	background: green[100],
                // 	backgroundLight: green[50],
                // },
                // warning: {
                // 	darker: orange[700],
                // 	dark: orange[600],
                // 	main: orange[500],
                // 	light: orange[400],
                // 	lighter: orange[300],
                // 	lightest: orange[200],
                // 	background: orange[100],
                // 	backgroundLight: orange[50],
                // },
                // error: {
                // 	darker: red[700],
                // 	dark: red[600],
                // 	main: red[500],
                // 	light: red[400],
                // 	lighter: red[300],
                // 	lightest: red[200],
                // 	background: red[100],
                // 	backgroundLight: red[50],
                // 	contrastText: yellow[100], // <Chip color="error" /> fails without this.
                // },
                primary: assignPaletteColors(indigo),
                secondary: assignPaletteColors(purple),
                info: assignPaletteColors(blue),
                success: assignPaletteColors(green),
                warning: assignPaletteColors(orange),
                error: assignPaletteColors(red),
                // TODO: check. orange color is duplicated (in warning)
                orange: assignPaletteColors(orange),
                amber: assignPaletteColors(amber),
                yellow: assignPaletteColors(yellow),
                lime: assignPaletteColors(lime),
                emerald: assignPaletteColors(emerald),
                teal: assignPaletteColors(teal),
                cyan: assignPaletteColors(cyan),
                sky: assignPaletteColors(sky),
                violet: assignPaletteColors(violet),
                fuchsia: assignPaletteColors(fuchsia),
                pink: assignPaletteColors(pink),
                rose: assignPaletteColors(rose),
                /*
                    orderStatus: {
                        // 1
                        // ordered: { link: grey[900], linkHover: grey[800], chip: grey[600], chipBackground: grey[100] } as OrderStatusColor,
                        ordered: { link: grey[900], linkHover: grey[800], chipLabel: zinc[700], chipBackground: alpha(zinc[600], 0.1) } as OrderStatusColor,

                        // 2: "Отправлен поставщику",
                        sentToSupplier: { link: yellow[600], linkHover: yellow[500], chipLabel: yellow[700], chipBackground: yellow[100] } as OrderStatusColor,

                        // 4: "Подтвержден поставщиком",
                        //		validatedBySupplier: StatusColor;

                        // 5: "Отменен поставщиком",
                        // canceledBySupplier: { link: red[500], linkHover: red[400], chip: red[700], chipBackground: red[100] } as OrderStatusColor,
                        // canceledBySupplier: { link: red[500], linkHover: red[400], chip: red[700], chipBackground: alpha(red[500], 0.15) } as OrderStatusColor,
                        canceledBySupplier: {
                            link: orange[700],
                            linkHover: orange[500],
                            // chipLabel: orange[700],
                            // chipBackground: alpha(orange[500], 0.15),
                            chipLabel: yellow[700],
                            chipBackground: alpha(yellow[500], 0.15),
                        } as OrderStatusColor,

                        // 6: "Ожидается на складе testtestov",
                        expectedInWarehouse: {
                            link: purple[500],
                            linkHover: purple[400],
                            chipLabel: purple[700],
                            chipBackground: purple[100],
                        } as OrderStatusColor,

                        // 7: "Получен",
                        //received: { main: green[500], hover: green[400] },

                        // 8: "На складе testtestov",
                        inWarehouse: { link: blue[500], linkHover: blue[400], chipLabel: blue[700], chipBackground: blue[100] } as OrderStatusColor,

                        // 9: "Отправлен заказчику",
                        sentToCustomer: { link: green[600], linkHover: green[500], chipLabel: green[700], chipBackground: green[100] } as OrderStatusColor,

                        // 12: "Отменен администратором",
                        // canceledByAdmin: { link: red[700], linkHover: red[600], chip: red[700], chipBackground: red[100] } as OrderStatusColor,
                        canceledByAdmin: { link: red[700], linkHover: red[600], chipLabel: red[700], chipBackground: alpha(red[500], 0.15) } as OrderStatusColor,

                        // 13: "Запрошен возврат",
                        //returnRequested: StatusColor;

                        // 14: "Возврат одобрен, ожидается на складе",
                        //returnApproved: StatusColor;

                        // 15: "Возврат отклонен",
                        //returnRejected: StatusColor;

                        // 16: "Возврат принят на складе",
                        //returnAccepted: StatusColor;

                        // 17: "Отменен заказчиком",
                        //canceledByCustomer: StatusColor;

                        // 18: "Принят в ПВЗ",
                        //acceptedInShipmentPoint: StatusColor; // Pickup point?

                        // 19: "Передан в службу доставки",
                        //transferredToDeliveryService: StatusColor;

                        // 20: "Передан в службу доставки (собств.)"
                        //transferredToOwnDeliveryService: StatusColor;
                    },
                    */
                stockType: {
                    stock: {
                        main: purple[500],
                        // purple[300] lightened by 20%
                        stored: '#e0c3fe',
                        // purple[400] lightened by 20%
                        occupied: '#cd9dfd',
                        // mixed blue and purple
                        storedSelected: '#C2ADFD',
                        // mixed blue and purple
                        occupiedSelected: '#9A83FA',
                        occupiedBorder: purple[950],
                    },
                    crossdocking: {
                        main: yellow[400],
                        stored: yellow[200],
                        occupied: yellow[300],
                        // mixed blue[500] and yellow[300] take 30%
                        storedSelected: '#DACF67',
                        // mixed blue[500] and yellow[300] take 50%
                        occupiedSelected: '#B6BE87',
                        occupiedBorder: yellow[700],
                    },
                    // // Same as stock right now
                    // transfer: {
                    // 	main: purple[500],
                    // 	stored: purple[300],
                    // 	occupied: purple[400],
                    // 	// mixed blue and purple
                    // 	storedSelected: '#C2ADFD',
                    // 	// mixed blue and purple
                    // 	occupiedSelected: '#9A83FA',
                    // 	occupiedBorder: purple[950],
                    // } as StockTypeColor,
                },
                // } as PaletteColorOptions)
            } // & CssVarsPalette)
            : //
                // ****************************
                //
                // Palette values for DARK mode
                //
                // ****************************
                {
                    Alert: {
                        // colors should be like chip info colors
                        // infoStandardBg: alpha(blue[500], 0.15),
                        infoStandardBg: `color-mix(in oklab, ${blue[500]} 15%, transparent)`,
                        infoColor: blue[400],
                    },
                    Avatar: {
                        defaultBg: zinc[500],
                    },
                    Tooltip: {
                        bg: zinc[600],
                    },
                    grey: grey,
                    slate: slate,
                    zinc: zinc,
                    indigo: indigo, // only used for primary not having indigo[200]
                    purple: purple,
                    //  Avatar: {},
                    action: {
                    // hover: zinc[100],
                    },
                    background: {
                        default: zinc[900],
                        light: lighten(zinc[900], 0.05), // [800] is too light
                    },
                    // not working for some reason, error in console and app is dead.
                    // divider: 'color-mix(in oklab, var(--gp-palette-common-white) 10%, transparent)', // alpha(zinc[950] as string, 0.1),
                    divider: alpha('#ffffff', 0.1),
                    //divider: `color-mix(in oklab, ${'#ffffff'} 10%, transparent)`, // Unsupported for some reason
                    dividerTranslucent: 'color-mix(in oklab, var(--gp-palette-common-white) 5%, transparent)',
                    text: {
                        // primary: grey[900],
                        // secondary: grey[800],
                        // medium: grey[700],
                        // light: grey[600],
                        // muted: grey[500],
                        // disabled: grey[400],
                        // primary:  zinc[950],
                        // primary: '#fff',
                        primary: zinc[50], // catalyst uses 'white' color
                        // secondary: zinc[800],
                        secondary: zinc[100],
                        // medium: zinc[700],
                        medium: zinc[200],
                        // light: zinc[600],
                        light: zinc[300],
                        // muted: zinc[500],
                        muted: zinc[400],
                        // disabled: zinc[400],
                        disabled: zinc[500],
                        // translucent: zinc[300],
                        translucent: zinc[600],
                    },
                    neutral: {
                        // dark: grey[700],
                        // main: grey[500],
                        // light: grey[300],
                        // lighter: grey[200],
                        // //lightest: grey[100],
                        dark: zinc[700],
                        main: zinc[500],
                        light: zinc[300],
                        lighter: zinc[200],
                        //lightest: grey[100],
                        contrastText: '#ffffff', // <Chip color="neutral" /> fails without this.
                    },
                    primary: assignPaletteColors(indigo),
                    secondary: assignPaletteColors(purple),
                    info: assignPaletteColors(blue),
                    success: assignPaletteColors(green),
                    warning: assignPaletteColors(orange),
                    error: assignPaletteColors(red),
                    orange: assignPaletteColors(orange),
                    amber: assignPaletteColors(amber),
                    yellow: assignPaletteColors(yellow),
                    lime: assignPaletteColors(lime),
                    emerald: assignPaletteColors(emerald),
                    teal: assignPaletteColors(teal),
                    cyan: assignPaletteColors(cyan),
                    sky: assignPaletteColors(sky),
                    violet: assignPaletteColors(violet),
                    fuchsia: assignPaletteColors(fuchsia),
                    pink: assignPaletteColors(pink),
                    rose: assignPaletteColors(rose),
                    stockType: {
                        stock: {
                            main: purple[500],
                            // purple[300] lightened by 20%
                            stored: '#e0c3fe',
                            // purple[400] lightened by 20%
                            occupied: '#cd9dfd',
                            // mixed blue and purple
                            storedSelected: '#C2ADFD',
                            // mixed blue and purple
                            occupiedSelected: '#9A83FA',
                            occupiedBorder: purple[950],
                        },
                        crossdocking: {
                            main: yellow[400],
                            stored: yellow[200],
                            occupied: yellow[300],
                            // mixed blue[500] and yellow[300] take 30%
                            storedSelected: '#DACF67',
                            // mixed blue[500] and yellow[300] take 50%
                            occupiedSelected: '#B6BE87',
                            occupiedBorder: yellow[700],
                        },
                    },
                }),
    };
};
// const assignPaletteColors = (color: Omit<Color, 'A100' | 'A200' | 'A400' | 'A700'>): PaletteColor => {
const assignPaletteColors = (color) => {
    return {
        950: color[950],
        900: color[900],
        800: color[800],
        // black: color[900]
        // darkest: color[800],
        darker: color[700],
        dark: color[600],
        main: color[500],
        light: color[400],
        lighter: color[300],
        lightest: color[200],
        background: color[100],
        backgroundLight: color[50],
        /**
         * `<Chip color="color" />` fails without this.
         */
        contrastText: color[100],
    };
};
